<template>
  <div class='container'>
    <div class="main">
      <nav class="left-nav">
        <div style="text-align: center;"><img src="/img/logo.png" /></div>
        <ul>
          <li v-for="(nav,index) in navs" :key="index" :class="{'active': nav.active}"  >
            <router-link v-if="(nav.isChild)" :to="nav.path"  @click="changeActive(nav)">{{ nav.title }}</router-link>
            
            <a v-else @click="goTo(nav.name)" style="cursor: pointer">{{ nav.title }}</a>
            <aside v-if="nav.num">{{ nav.num }}</aside>
          </li>
        </ul>
      </nav>
      <div class="right-main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'relation-index',
  data () {
    return {
      navs: [
        {
          title: "好友/关注/粉丝",
          name: 'relation-friend',
          path: '/relation-friend',
          isChild: 1,
          num: 0,
          active: false
        },
        {
          title: "我的推广",
          name: 'relation-promotion',
          path: '/relation-promotion',
          isChild: 1,
          num: 0,
          active: false
        },
        {
          title: "我的团队",
          name: 'relation-team', // 
          path: '/relation-team', // 

          isChild: 1,
          num: 0,
          active: false
        },
        {
          title: "我的企业", // 
          name: 'relation-company-join',
          path: '/relation-company-join',
          isChild: 1,
          num: 0,
          active: false
        },

        {
          title: "我的社区", // 
          name: 'relation-community',
          path: '/relation-community',
          isChild: 1,
          num: 0,
          active: false
        },

      ]
    }
  },
  mounted () {
    this.initNav();
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.initNav();
      },
      // 深度观察监听
      deep: true
    },
  },

  methods: {
    goTo (name) {
      let routeData = this.$router.resolve({ name: name, });
      window.open(routeData.href, '_blank');

    },

    initNav () {
      console.log("this.$route.path",this.$route.path);

      var has=false;
      this.navs.forEach((item) => {
        if(item.path == this.$route.path){
          item.active=true;
          has=true;
        }else {
          item.active=false;
          //item.active = (item.path == this.$route.path || this.$route.path.includes(item.name) ? true : false);
        }
      });

      if(has==false){
          this.navs.forEach((item) => {
          item.active = (item.path == this.$route.path || this.$route.path.includes(item.name) ? true : false);

        });
      }

      console.log("this.navs",this.navs);
      this.$forceUpdate();
    },

    changeActive (nav) {
      var that = this;
      var has=false;
      this.navs.forEach((item) => {
        if (item.name == nav.name) {
          item.active = true;
          has=true;
        } else {
          item.active = false;
        }
      });

      if(has==false){
          this.navs.forEach((item) => {
          item.active = (item.path == this.$route.path || this.$route.path.includes(item.name) ? true : false);
        });
      }
    },
  }


}
</script>

<style lang="scss" scoped>
.main{
  display: flex;
  min-height: 500px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  .left-nav {
    width: 200px;
    min-width: 200px;
    border-radius: 6px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    ul {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .active{
        background-color: #4c71db;
        color:#ffffff;

        a{
          color: #fff;
        }
      }
      li {
        position: relative;
        text-align: center;
        a {
          padding: 0 24px;
          line-height: 60px;
          // line-height: 72px;
          display: block;
          // font-size: 22px;
          font-size: 16px;
          &.router-link-active {
            background-color: #4c71db;
            color: #fff;
          }
        }
        aside {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 0;
          right: 0;
          color: #fff;
          background-color: #ff4e4e;
          border-radius: 10px;
          line-height: 20px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
  .right-main{
    border-radius: 6px;
    flex: 1;
    background-color:  #fbfbfb
  }
}

</style>